import React, { useEffect, useState } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import FormUsuario from "../../components/usuarios/FormUsuario";
import Loader from "../../components/Loader";
import { useParams, useNavigate } from 'react-router-dom';
import { formSchema } from "../../validaciones/validacionUsuarios";

const DetalleUsuarioPage = () => {
  const [error, setError] = useState(null);
  const [tipo_usuario, setTipo_usuario] = useState([])
  const [sucursales, setSucursales] = useState([])
  const [sucursalesUsuario, setSucursalesUsuario] = useState([])
  const [secciones, setSecciones] = useState([])
  const [isLoading, setIsLoading] = useState({cargarSucursalPermiso: true, cargarUsuario: true});
  const navigate = useNavigate();
  const { id } = useParams();

  const [datos, setDatos] = useState({
    id,
    nombre:"",
    apellido_paterno:"",
    apellido_materno:"",
    correo:"",
    telefono:"",
    pais_telefono:"",
    esValidoTelefono:false,
    contra:"",
    foto:"",
    tipo:3,
    estatus:1
  })

  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log(name, value);
    setDatos({ ...datos, [name]: value });
  };

  const handlePermisos = (item,valor) => {
    let seccionesArray = secciones;
    seccionesArray[item] = valor;
    setSecciones(seccionesArray);
  };

  const handleSucursal = (e) => {
    setSucursalesUsuario(e);
  }

  function onChangeValidity(phoneNumber) {
    if (datos.esValidoTelefono !== phoneNumber) {
      setDatos(x => ({...x, esValidoTelefono: phoneNumber}));
    }
  }

  function onChangePhone(phoneNumber) {
    if(datos.telefono !== phoneNumber){
      setDatos(x => ({...x, telefono: phoneNumber}));
    }
  }

  function onChangeCountry (country) {
    if(datos.pais_telefono !== country){
      setDatos(x => ({...x, pais_telefono: country}));
    }
  }

  useEffect(() => {
    function obtenerSucursalesPermisos() {
      fetch("/p_sucursal_permiso_usuario",{
        method: "POST",
        headers:{
          "Content-Type": "application/json",
        },
        body: JSON.stringify({id})
      })
      .then((res) => res.json())
      .then((data) => {
        //console.log('la data',data);
        if(data.status === 1){
          setTipo_usuario(data.data[0].map((item) => { return { value: item.VALOR_TIPO, label: item.NOMBRE_TIPO } }))
          setSucursales(data.data[1].map((item) => { return { value: item.ID_SUC, label: item.NOMBRE_SUCURSAL_SUC } }))
          let seccionesArray = [];
          seccionesArray = data.data[2].map((item) => { return { value: item.ID_SEC, label: item.NOMBRE_SEC, esVer: true, esCrear:true, esEditar:true, esEliminar:true } });
          setSecciones(seccionesArray);
          setIsLoading(x => ({...x, cargarSucursalPermiso: false}));
          obtenerUsuario(seccionesArray)
        }
      });
    }

    function obtenerUsuario(seccionesArray) {
      // eslint-disable-next-line
      if(id != 0){
        fetch("/p_usuario",{
          method: "PATCH",
          headers:{
            "Content-Type": "application/json",
          },
          body: JSON.stringify({id})
        })
        .then((res) => res.json())
        .then((data) => {
          if(data.status === 1){
            console.log(data);
            setDatos((x)=>({
              ...x,
              id,
              nombre:data.data[0][0].NOMBRE_USR || "",
              apellido_paterno:data.data[0][0].APELLIDO_PATERNO_USR || "",
              apellido_materno:data.data[0][0].APELLIDO_MATERNO_USR || "",
              correo:data.data[0][0].CORREO_USR || "",
              telefono:data.data[0][0].TELEFONO_USR || "",
              pais_telefono:data.data[0][0].PAIS_TELEFONO_USR || "",
              tipo:data.data[0][0].TIPO_USR || "",
              estatus:data.data[0][0].ESTATUS_USR || 1
            }));
            setSucursalesUsuario(data.data[1].map((item) => { return { value: item.ID_SUC, label: item.NOMBRE_SUCURSAL_SUC } }));

            for (let index = 0; index < seccionesArray.length; index++) {
              const element = seccionesArray[index];
              const seccion = data.data[2].find((item) => item.ID_SEC_PER === element.value);
              
              seccionesArray[index].esVer = seccion?.CONSULTAR_PER ?? false;
              seccionesArray[index].esCrear = seccion?.CREAR_PER ?? false;
              seccionesArray[index].esEditar = seccion?.ACTUALIZAR_PER ?? false;
              seccionesArray[index].esEliminar = seccion?.BORRAR_PER ?? false;
            }
            setSecciones(seccionesArray);
            setIsLoading(x => ({...x, cargarUsuario: false}));
          } 
        });
      }
      else{
        setIsLoading(x => ({...x, cargarUsuario: false}));
      }
    }

    obtenerSucursalesPermisos();
  }, [id]);

  const handleSave = () => {
    const result = formSchema.safeParse({...datos, telefono: datos.telefono.replace(/\D/g, ''),sucursales:sucursalesUsuario});
    if (!result.success) {
      console.log(result.error.errors);
      console.log(result.error.flatten().fieldErrors);
      setError(result.error.flatten().fieldErrors)
      return;
    }
    // eslint-disable-next-line
    if (id == 0) {
      // Create new sucursal
      try {
        fetch("/p_usuario",{
          method: "POST",
          headers:{
            "Content-Type": "application/json",
          },
          body: JSON.stringify({datos, sucursalesUsuario, secciones})
        })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);

          if(data.data === 1){
            // Success
            navigate(-1);
          }
          else if(data.data === 2){
            window.notie.alert({ type: 'warning', text: 'El correo ya existe' });
          }
          else{
            window.notie.alert({ type: 'warning', text: 'El teléfono ya existe' });
          }
        });
      } catch (error) {
        console.error('Error:', error);
      }
    }
    else {
      console.log('secciones', secciones);
      
      // Update sucursal
      try {
        fetch("/p_usuario",{
          method: "PUT",
          headers:{
            "Content-Type": "application/json",
          },
          body: JSON.stringify({datos, sucursalesUsuario, secciones})
        })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if(data.status === 1){
            // Success
            navigate(-1);
          }
        });
      } catch (error) {
        console.error('Error:', error);
      }
    }
  }

  return (
    <>
      <MasterLayout>
        { (isLoading.cargarSucursalPermiso || isLoading.cargarUsuario) ? 
          <Loader /> : 
          <FormUsuario 
            datos={datos} 
            handleChange={handleChange} 
            handleSave={handleSave}
            tipo_usuario={tipo_usuario} 
            sucursales={sucursales} 
            secciones={secciones} 
            sucursalesUsuario={sucursalesUsuario}
            handlePermisos={handlePermisos}
            handleSucursal={handleSucursal}
            onChangeValidity={onChangeValidity}
            onChangePhone={onChangePhone}
            onChangeCountry={onChangeCountry}
            error={error}
          />
        }
      </MasterLayout>
    </>
  );
};

export default DetalleUsuarioPage;
